/**
 * Репозиторий сущности «Событие календаря».
 * CRUD, мягкое удаление и запись в очередь синхронизации — в базовой фабрике
 * (`src/shared/db/repository.ts`). Здесь только специфичные запросы.
 */

import { db } from '@/shared/db/database';
import { createRepository } from '@/shared/db/repository';
import type { CalendarEvent } from '@/shared/db/schema';

export const eventsRepo = createRepository<CalendarEvent>('events', db.events);
